import { produce } from "immer";

import type { YourInsightFilterState } from "../types/filters/yourInsights";
import {
    YourInsightFilterContentType,
    YourInsightFilterContentSubType,
} from "../types/filters/yourInsights";

import { zustandStore } from "./zustand.helpers";

export interface YourInsightFilterActions {
    setTypes: (
        contentType: YourInsightFilterContentType,
        contentSubType?: YourInsightFilterContentSubType,
    ) => void;
}

const initialFilterState: YourInsightFilterState = {
    contentType: YourInsightFilterContentType.INSIGHTS,
    contentSubType: YourInsightFilterContentSubType.PACKAGED_INSIGHTS,
    filters: {}, // TODO: Update when filters supported for your insights tab
};

export const { store: yourInsightFilterStore } = zustandStore<
    YourInsightFilterState,
    YourInsightFilterActions
>("YourInsightFilter", initialFilterState, (set, get) => ({
    setTypes: (
        contentType: YourInsightFilterContentType,
        contentSubType?: YourInsightFilterContentSubType,
    ) => {
        set(() => {
            const state: YourInsightFilterState = get();
            return produce(state, (draft) => {
                // set type to new value
                draft.contentType = contentType;
                draft.contentSubType = contentSubType;
                return draft;
            });
        });
    },
}));
